import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../components/Provider/CommonProvider';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import { IoClose } from 'react-icons/io5';
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch';

const AdminAgeWarningModal = ({ show, handleClose }) => {
    const [heading, setHeading] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState(0);
    const [loading, setLoading] = useState(false);
    const { fetchRequest } = useMyContext();
    const baseURL = process.env.REACT_APP_Baseurl;

    useEffect(() => {
        if (show) {
            fetchSettings();
        }
    }, [show]);

    const fetchSettings = async () => {
        try {
            const response = await fetchRequest({
                method: 'get',
                url: `${baseURL}/admin/settings/age-warning`,
            });
            if (response?.status) {
                setHeading(response.data.age_warning_heading || '');
                setDescription(response.data.age_warning_description || '');
                setStatus(response.data.age_warning_status || 0);
            }
        } catch (error) {
            console.error('Error fetching age warning settings:', error);
        }
    };

    const handleUpdate = async () => {
        setLoading(true);
        try {
            const response = await fetchRequest({
                method: 'post',
                url: `${baseURL}/admin/settings/age-warning`,
                params: {},
                data: {
                    age_warning_heading: heading,
                    age_warning_description: description,
                    age_warning_status: status
                },
            });
            if (response?.status) {
                toast.success(response.message);
                handleClose();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Error updating age warning settings');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="packageModel">
            <Modal.Header className="theme-bg-color theme-border-bottom-secondary">
                <Modal.Title className="theme-text-color">Age Warning Settings</Modal.Title>
                <button type="button" className="bg-transparent theme-text-color border-0" onClick={handleClose}>
                    <IoClose size={25} fill="currentColor" />
                </button>
            </Modal.Header>
            <Modal.Body className="theme-bg-color">
                <div className="mb-3 text-start d-flex align-items-center justify-content-between">
                    <MessageLabel text="Age Warning Status" className="mandatorySimple mb-0" />
                    <AdminSwitch id="age-warning-status" name={'status'} checked={status === 1} onChange={(e) => setStatus(e.target.checked ? 1 : 0)} />
                </div>
                <div className="mb-3 text-start">
                    <MessageLabel text="Heading" className="mandatorySimple mb-2" />
                    <AdminCustomInput
                        value={heading}
                        onChange={(e) => setHeading(e.target.value)}
                        placeholder="Enter Heading"
                    />
                </div>
                <div className="mb-3 text-start">
                    <MessageLabel text="Description" className="mandatorySimple mb-2" />
                    <textarea
                        className="custom-input custom-input-border w-100 custom-placeholder bg-transparent theme-text-color"
                        rows={5}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter Description"
                        style={{ borderRadius: '8px', padding: '10px' }}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className="theme-bg-color border-0">
                <button type="button" className="bg-transparent btn theme-text-color m-0 sliderBtnText" onClick={handleClose}>Close</button>
                <AdminCustomButton saveMethod={handleUpdate} saveText="Update" loading={loading} className="m-0" />
            </Modal.Footer>
        </Modal>
    );
};

export default AdminAgeWarningModal;
